import { PERMISSIONS, type Permission } from '@/shared/constants';
import type { TabConfig } from '@/features/access-control';
import { ALERT_TYPE, type AlertType } from './domain';

// A type missing here can't be acted on by anyone but a superuser.
export const ALERT_TYPE_PERMISSION: Record<AlertType, Permission> = {
	[ALERT_TYPE.SOAP_ALERT]: PERMISSIONS.ALERTS_FOAM,
	[ALERT_TYPE.DEVICE_DISCONNECTED]: PERMISSIONS.ALERTS_CONEXIONS,
	[ALERT_TYPE.MACHINE_WITHOUT_SALES]: PERMISSIONS.ALERTS_SALES,
	[ALERT_TYPE.DEVICE_OUT_OF_SERVICE]: PERMISSIONS.ALERTS_OOS,
	[ALERT_TYPE.PAYMENT_INACTIVE]: PERMISSIONS.ALERTS_PAYMENT_INACTIVES,
};

export const ALERT_TYPE_I18N_KEY = {
	[ALERT_TYPE.MACHINE_WITHOUT_SALES]: 'machineWithoutSales',
	[ALERT_TYPE.DEVICE_DISCONNECTED]: 'disconnectionDevice',
	[ALERT_TYPE.SOAP_ALERT]: 'soapAlert',
	[ALERT_TYPE.DEVICE_OUT_OF_SERVICE]: 'deviceOutOfService',
	[ALERT_TYPE.PAYMENT_INACTIVE]: 'paymentInactive',
} as const satisfies Record<AlertType, string>;

export const ALERT_TYPE_PERMISSIONS = Object.values(ALERT_TYPE_PERMISSION);

export const ALERTS_TABS = ['messages', 'configurations'];
export type AlertsTab = (typeof ALERTS_TABS)[number];

export const ALERTS_TABS_CONFIG: TabConfig<AlertsTab>[] = [
	{ tab: 'messages' },
	{ tab: 'configurations', requiredPermission: [PERMISSIONS.ALERTS_READ] },
];

export const ALERTS_DETAILS_TABS = ['info', 'history'];
export type AlertsDetailsTab = (typeof ALERTS_DETAILS_TABS)[number];
export const ALERTS_TABS_CONFIG_DETAILS: TabConfig<AlertsDetailsTab>[] = [
	{ tab: 'info' },
	{ tab: 'history' },
];

// Apart from TABLE_IDS.ALERT_HISTORY (the no-sales machines table) so their sort and filters don't mix.
export const ALERT_EVENTS_HISTORY_TABLE_ID = 'alert-events-history';
